module.exports = __webpack_public_path__ + "img/img (7).1fbd3b26.png";